const exerciseSkills = {
  skills: [
    {
      id: 1,
      name: 'One Choice',
      visible: true,
    },
    {
      id: 2,
      name: 'Fill In The Blank',
      visible: true,
    },
    {
      id: 3,
      name: 'Unscramble',
      visible: false,
    },
    {
      id: 4,
      name: 'Matching',
      visible: true,
    },
    {
      id: 5,
      name: 'Word Puzzles',
      visible: false,
    },
    {
      id: 6,
      name: 'Underlined',
      visible: false,
    },
    {
      id: 7,
      name: 'Select Word',
      visible: true,
    },
  ],
};

export default exerciseSkills;
